import { generateScope } from "seneca-common/features/calculation/logic/generation/generateScope";
import parseTemplate from "seneca-common/features/calculation/logic/templating/parseTemplate";
import { TemplatePartTypes } from "seneca-common/features/calculation/logic/templating/types";
import { splitPartsByType } from "seneca-common/features/calculation/logic/templating/utils/splitPartsByType";
import { ContentSource } from "seneca-common/features/calculation/module/types";

export type OldImageLabel = {
  x: number;
  y: number;
  value: string;
  isAnswer?: boolean;
};

export type OldContentSource = {
  allowCalculator: boolean;
  questionTemplate: string;
  generationTemplate: string;
  validationScript?: string;
  url?: string;
  imageLabels: OldImageLabel[];
};

export function mapToNewContentSource({
  allowCalculator,
  generationTemplate,
  imageLabels,
  questionTemplate: entireTemplate,
  url,
  validationScript
}: OldContentSource): ContentSource {
  const [questionTemplate, markSchemeTemplate, answersTemplate] =
    splitPartsByType(
      parseTemplate(generateScope(generationTemplate), entireTemplate),
      TemplatePartTypes.STEP_DELIMITER
    ).map(parts => parts.map(it => it.original).join(""));

  return {
    questionTemplate,
    answersTemplate,
    markSchemeTemplate,
    calculatorEnabled: allowCalculator,
    generationScript: generationTemplate,
    imageLabels:
      imageLabels?.map(it => ({
        x: it.x,
        y: it.y,
        template: it.value,
        isAnswer: it.isAnswer
      })) ?? [],
    imageUrl: url,
    validationScript: validationScript || ""
  };
}
